import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import * as React from "react";

export default function RunnerSelector({runners, selectedRunner, handleRunnerSelected}) {
    if (!runners.length) {
        return (
            <Grid style={{height: 200}} container justify={"center"} alignItems={"center"}>
                <Grid item xs={12}>
                    <Typography align={"center"}>No runners connected</Typography>
                </Grid>
            </Grid>
        );
    }

    return (
        <List style={{height: 200}}>
            {
                runners.map(runner => (
                    <div key={`runner_${runner.id}`}>
                        <ListItem button selected={selectedRunner && runner.id === selectedRunner.id}>
                            <ListItemText
                                primary={runner.hostname}
                                secondary={`${runner.os} ${runner.arch}`}
                                onClick={() => handleRunnerSelected(runner.id)}
                            />
                        </ListItem>
                        <Divider/>
                    </div>
                ))
            }
        </List>
    );
}